export enum CRITICALITY_LABELS {
  CRITICAL = 'Critical',
  HIGH = 'High',
  MEDIUM = 'Medium',
  LOW = 'Low'
}

export default CRITICALITY_LABELS;
